import { post , get , put, del} from '../axiosconfig'

import qs from 'qs';
export default {
  getActivelist(params){
    params = qs.stringify(params);
    return get('/zsc/web/public/data', params)
  },
  //获取成长值记录
  getGrowingLog(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/growth_value_log', params)
  },
  getSendRecord(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/account/releasing_alert_record', params)
  },


}



// WEBPACK FOOTER //
// ./src/api/public/shop_api.js